import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Input } from 'antd';
import { QrcodeOutlined } from '@ant-design/icons';
import * as SERVICE from '../../../constants/service.types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { socketEmitEvent } from '../../../redux/actions';
import { APP_ID } from '../../../constants/system.keys';
const HOSTNAME = window.location.hostname
const LOGIN_FORM_CLASS = {
  "cloudcam1.hoasengroup.vn": {input: "hoasen-input ", submit: "hoasen-submit"}
}
const LoginByAccessTokenComponent = ({ onBack }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const accessToken = useRef(null);
  const [, forceUpdate] = useState();
  const { authData } = useSelector((state) => state);

  useEffect(() => {
    forceUpdate({});
  }, []);

  useEffect(() => {
    if (accessToken.current) {
      accessToken.current.input.focus();
    }
  }, [accessToken]);

  useEffect(() => {
    if (authData) {
      const { result, message } = authData;
      if (result === -4) {
        form.setFields([
          {
            name: 'accessToken',
            errors: [message],
          },
        ]);
      }
    }
  }, [authData, form]);
  const handleLogin = (values) => {
    let data = {
      accessToken: values.accessToken,
      appId: APP_ID,
      encrypted: 1,
      agent: `${window.navigator.userAgent}_web`
    };
    let dataObj = {
      appServiceType: SERVICE.AUTHENTICATION,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  return (
    <div className="_2sd-step-login-component">
      <div />
      <Form
        className="form-login"
        form={form}
        size="large"
        name="form_login"
        onFinish={handleLogin}
      >
        <Form.Item
          name="accessToken"
          rules={[
            {
              required: true,
              message: t('Please enter the access token!'),
            },
          ]}
        >
          <Input
            ref={accessToken}
            className={LOGIN_FORM_CLASS[HOSTNAME]?.input || ''}
            prefix={<QrcodeOutlined style={{color: '#0e9347'}}/>}
            placeholder={t('Access Token')}
          />
        </Form.Item>
        <div className="feedback" />
        <div className="confirm-btn" style={{ paddingTop: '5px' }}>
          <Button
            shape="round"
            onClick={() => {
              form.resetFields();
              return onBack();
            }}
          >
            {t('Back')}
          </Button>
          <Form.Item shouldUpdate={true}>
            {() => (
              <Button
                shape="round"
                htmlType="submit"
                type="primary"
                className={LOGIN_FORM_CLASS[HOSTNAME]?.submit || ''}
                disabled={
                  !form.isFieldsTouched(true) ||
                  form.getFieldsError().filter(({ errors }) => errors.length)
                    .length
                }
              >
                {t('Continue')}
              </Button>
            )}
          </Form.Item>
        </div>
      </Form>
      <div />
    </div>
  );
};

export default LoginByAccessTokenComponent;
